import * as React from "react";
import {
  EditableFieldWrapper,
  StyledPencilIcon,
} from "src/components/shared/Editable/Editable.components";
import { StyledEditableTextArea } from "./EditableTextArea.components";

interface Props extends React.ComponentPropsWithoutRef<"textarea"> {
  editableValue?: string;
  isDisabled: boolean;
  isDisabledSetter: React.Dispatch<React.SetStateAction<boolean>>;
  isTaskCard?: boolean;
  numOfChars?: number;
}

const EditableTextArea: React.FunctionComponent<Props> = ({
  editableValue,
  isDisabled,
  onBlur,
  isDisabledSetter,
  numOfChars,
  isTaskCard = false,
  ...props
}) => {
  const inputRef = React.useRef<null | HTMLTextAreaElement>(null);

  React.useEffect(() => {
    if (!isDisabled) {
      inputRef?.current?.focus();
    }
  }, [isDisabled]);

  const handleTextAreaResize = () => {
    if (inputRef.current) {
      const el = inputRef.current;
      el.style.height = "1px";
      const { scrollHeight } = el;
      el.style.height = scrollHeight + "px";
    }
  };

  React.useEffect(() => {
    handleTextAreaResize();
  }, [editableValue]);

  return (
    <EditableFieldWrapper isTaskCard={isTaskCard}>
      <StyledEditableTextArea
        rows={1}
        disabled={isDisabled}
        value={editableValue}
        onBlur={onBlur}
        isTaskCard={isTaskCard}
        numOfChars={numOfChars}
        isAddedTask={editableValue !== "Add a new task"}
        ref={inputRef}
        {...props}
      />
      <StyledPencilIcon
        data-cy="pencil"
        onClick={() => isDisabledSetter(false)}
      />
    </EditableFieldWrapper>
  );
};

export default EditableTextArea;
